import React, { useRef, useState, useEffect, useContext } from "react";
import { Button, Col, Modal, Row, Form, InputGroup } from "react-bootstrap";
import send from "../../Assets/Images/send.png";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";

import { useNavigate } from "react-router-dom";
import FutureBuyAndSellMarket from "./FututeBuySellMarket";
import { FaCheckCircle, FaMinus, FaPlus } from "react-icons/fa";
import { precision_list_json } from "../constants";
import FutureBuyAndSellLimit from "./FutureBuySellLimit";
import FutureBuyAndSellStopLimit from "./FutureBuySellStopLimit";
import InfoPopUp from "../../Common/InfoPopUp";
import { FutureDataContent } from ".";
import { useSelector } from "react-redux";
import ModalContent from "../../Common/Modal";
import { Box } from "@mui/material";
import { ContainedButton } from "../../Common/Buttons";
import InfoIcon from "@mui/icons-material/Info";

const FUTURELENDINGURL = WEBSERVICE + "/fMargin/";

const FutureBuyAndSell = () => {
  const {
    currencycode,
    basecurrency,
    ltp,
    assetPairName,
    assetpair,
    derivativeAssets,
    updateBalance,
    setRefresh,
    refresh,
    setSellData,
    setBuyData,
  } = useContext(FutureDataContent);
  const selectedAsset = "";
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const [show, setShow] = useState(false);
  const [showStopLimit, setShowStopLimit] = useState(false);
  const [showMargin, setShowMargin] = useState(false);
  const [showMarginInfo, setShowMarginInfo] = useState(false);
  const [showRange, setShowRange] = useState(false);
  const [showRangeInfo, setShowRangeInfo] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("MARKET");
  const [isOrderTypeDropdownEnabled, setIsOrderTypeDropdownEnabled] =
    useState(false);
  const [selectedOrderType, setSelectedOrderType] = useState("GTC");
  const [activeTabForSpot, setActiveTabForSpot] = useState("orderType");

  const [showOrderTypeDropdown, setShowOrderTypeDropdown] = useState(false);
  const [buySellPillsClassStatus, setBuySellPillsClassStatus] = useState(null);
  const [orderValues, setOrderValues] = useState({
    disclosedQuantity: null,
    limitAmountForOco1: null,
    limitTotalForOco1: null,
    limitPriceForOco1: null,
    limitAmountForOco2: null,
    limitTotalForOco2: null,
    limitPriceForOco2: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [balanceList, setBalanceList] = useState([]);
  const [selectedBuyingAssetBalance, setSelectedBuyingAssetBalance] =
    useState(null);
  const [selectedSellingAssetBalance, setSelectedSellingAssetBalance] =
    useState(null);
  const [percentageValue, setPercentageValue] = useState(null);
  const [themeColor, setThemeColor] = useState("Dark"); // Example theme state
  const [selectedLeverageMarginType, setSelectedLeverageMarginType] =
    useState(parseInt(localStorage.getItem("selected_margin_type_future") || 2));
  const [selelectedMarginWalletBalance, setSelectedMarginWalletBalance] =
    useState(0);
  const [selectedContractBalance, setSelectedContractBalance] = useState(0);

  const [baseLeverage, setBaseLeverage] = useState(2);
  const [finalbaseLeverage, setFinalBaseLeverage] = useState(
    parseInt(localStorage.getItem("selected_leverage_future")?.slice(0, -1)) ||
      2
  );
  const crossRange = ["2X", "125X"];
  const [baseRangeLeverage, setBaseRangeLeverage] = useState(2);
  const [baseInputLeverage, setBaseInputLeverage] = useState(2);

  const toggleCrossRange = (direction) => {
    setBaseLeverage((prev) =>
      direction === -1
        ? Math.max(2, Number(prev) - 1)
        : Math.min(125, Number(prev) + 1)
    );
  };

  const modalContentMap = {
    MARKET: {
      title: "MARKET",
      description: `Users can Buy and Sell at the current market price. Enter "Buying Amount" and click on BUY to place a BUY Market order. Enter "Selling Amount" and click on SELL to place a SELL Market order.`,
    },
    LIMIT: {
      title: "LIMIT",
      description: `You can create Buy and Sell limit offers at the price of your choice and the offers will reflect in Order Book and Open Orders. Enter "Amount", and Price and click on the BUY button for the BUY offer. Enter "Amount", and Price and click on the SELL button for the SELL offer.`,
    },
    "STOP-LIMIT": {
      title: "Stop-Limit",
      description: `You can set an offer range depending on market price for buy or sell trading. For BUY - Market order price should be less than stop price and limit price should be greater than stop price. For SELL - Market order price should be greater than stop price and limit price should be less than stop price.`,
    },
  };

  const selectedModal = modalContentMap[show];

  useEffect(() => {
    setBaseRangeLeverage(baseLeverage);
    setBaseInputLeverage(baseLeverage);
  }, [baseLeverage]);

  const handleRangeSliderValue = (value) => {
    if (value >= 2 && value <= 125) {
      setBaseRangeLeverage(value);
      setBaseInputLeverage(value);
      setBaseLeverage(Number(value));
    }
  };

  const handleRangeSliderByInput = (event) => {
    let value = event.target.value;

    if (value >= 2 && value <= 125) {
      setBaseInputLeverage(value);
      setBaseRangeLeverage(value);

      setBaseLeverage(value);
    } else {
      showToast("error", "Please provide a valid input");
    }
  };

  const handleConfirmBtn = () => {
    localStorage.setItem("selected_leverage_future", `${baseLeverage}X`);

    const selectedLeverage = baseLeverage;
    setFinalBaseLeverage(baseLeverage);

    if (selectedLeverage > 1) {
      renderAvailableBalance();
    } else {
      getUserTransaction();
      // this.renderContractBalance();
    }
  };

  useEffect(() => {
    if (finalbaseLeverage > 1) {
      renderAvailableBalance();
    } else {
      getUserTransaction();
      // this.renderContractBalance();
    }
  }, [
    selectedLeverageMarginType,
    basecurrency,
    finalbaseLeverage,
    updateBalance,
  ]);

  const getSpecificCurrencyPrecision = (param) => {
    let list = precision_list_json;
    let precision = 0;
    for (let i = 0; i < list.length; i++) {
      if (
        list[i].CURRENCYID == param ||
        list[i].CURRENCY == param.toUpperCase()
      ) {
        precision = list[i].PRECISION;
        break;
      }
    }
    return precision;
  };

  const renderAvailableBalance = async () => {
    setRefresh(!refresh);
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");
    const baseUrl = `${FUTURELENDINGURL}getMarginWalletByCurrency?uuid=${uuid}&currencyName=${basecurrency}&marginType=${selectedLeverageMarginType}&leverage=${finalbaseLeverage}`;
    try {
      const response = await axios.get(baseUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `BEARER ${accessToken}`,
        },
      });

      const precision = getSpecificCurrencyPrecision(currencycode);
      const availableBalance =
        response.data.availableBalance.toFixed(precision);
      const marginWalletBalance =
        response.data.marginWalletBalance.toFixed(precision);

      setSelectedSellingAssetBalance(availableBalance);
      setSelectedMarginWalletBalance(marginWalletBalance);
      setSelectedBuyingAssetBalance(availableBalance);
      setSelectedContractBalance(availableBalance);
    } catch (error) {
      console.error("Error fetching available balance:", error);
    }
  };

  const handleSelectLeverageMarginType = (type) => {
    localStorage.setItem("selected_margin_type_future", type);
    setSelectedLeverageMarginType(type);
  };

  const getUserTransaction = async () => {
    setRefresh(!refresh);
    setIsLoading(true);

    const userTransObj = {
      customerId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
    };

    const selectedMarginType = localStorage.getItem("selectedMarginType");
    if (selectedMarginType) {
      userTransObj.marginType = selectedMarginType;
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;
      if (result.error.error_data !== 0) {
        alert("Cannot fetch user balance");
      } else {
        setBalanceList(result.userBalanceList);

        // Store USD balance
        const usdBalance = result.userBalanceList.find(
          (item) => item.currencyCode === "USD"
        );
        if (usdBalance) {
          localStorage.setItem("usdbalance", usdBalance.closingBalance);
        }

        // Set selected asset balances
        const buyingAsset = localStorage
          .getItem("buying_crypto_asset")
          ?.toUpperCase();
        const sellingAsset = localStorage
          .getItem("selling_crypto_asset")
          ?.toUpperCase();
        const pricePrecision = 6;

        result.userBalanceList.forEach((item) => {
          if (item.currencyCode === currencycode) {
            setSelectedBuyingAssetBalance(
              Number(item.closingBalance).toFixed(pricePrecision)
            );
          }
          if (item.currencyCode === basecurrency) {
            setSelectedSellingAssetBalance(
              Number(item.closingBalance).toFixed(pricePrecision)
            );
          }
        });
      }
    } catch (error) {
      console.error(error);
      if (error.response?.status === 401) {
        showToast("error", "Session Timeout. Login Again");
        // Perform logout logic
        //logout
      }
    } finally {
      setIsLoading(false);
    }
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  // useEffect(() => {
  //   getUserTransaction();
  // }, [currencycode, basecurrency]);
  useEffect(() => {
    getFeesOfUser();
  }, []);

  const getFeesOfUser = async () => {
    let currencyId = "";

    if (basecurrency === "USD") {
      currencyId = "1";
    } else {
      currencyId = "16";
    }

    try {
      const response = await axios.get(
        `${WEBSERVICE}fTrade/tradingFeesByCurrency?currencyId=${currencyId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      console.log("feeeeeeeeee", response.data);
      const fee = (response.data.tradingFee + 0.1) / 100;
      setPercentageValue(fee);
      console.log("val fee", fee);
    } catch (error) {
      console.error("Error fetching fee:", error);
    }
  };

  const handleClose = () => setShow("");
  const handleCloseStopLimit = () => setShowStopLimit(false);
  const handleCloseMargin = () => setShowMargin(false);
  const handleCloseMarginInfo = () => setShowMarginInfo(false);
  const handleCloseRange = () => setShowRange(false);
  const handleCloseRangeInfo = () => setShowRangeInfo(false);

  useEffect(() => {
    setBaseLeverage(finalbaseLeverage);
    setBaseRangeLeverage(finalbaseLeverage);
    setBaseInputLeverage(finalbaseLeverage);
  }, [finalbaseLeverage, showRange]);
  const handleShowOrderTypeDropdown = (param) => {
    setOrderValues({
      disclosedQuantity: null,
      limitAmountForOco1: null,
      limitTotalForOco1: null,
      limitPriceForOco1: null,
      limitAmountForOco2: null,
      limitTotalForOco2: null,
      limitPriceForOco2: null,
    });

    if (param.toLowerCase() === "limit") {
      setShowOrderTypeDropdown(true);
    } else {
      setShowOrderTypeDropdown(false);
    }
  };

  console.log("baseLeverage", finalbaseLeverage);

  const makeClassToggle = (status) => {
    setBuySellPillsClassStatus(status);
  };

  const handleClick = (tab) => {
    setShow(tab);
  };

  return (
    <div>
      {/* Tab bar + Futures-specific controls */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div className="bs-tabbar">
          {["MARKET", "LIMIT", "STOP-LIMIT"].map((tab) => (
            <button
              key={tab}
              className={`bs-tab ${activeTab === tab ? "active-bs-tab" : ""}`}
              style={activeTab === tab ? { "--btn-color": btncolor } : {}}
              onClick={() => {
                setActiveTab(tab);
                handleShowOrderTypeDropdown(tab);
                makeClassToggle(true);
                setSellData("");
                setBuyData("");
              }}
            >
              {tab}
            </button>
          ))}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "6px", paddingRight: "8px" }}>
          <ContainedButton onClick={() => setShowMargin(true)}>
            {selectedLeverageMarginType === 2 ? "CROSS" : "ISOLATED"}
          </ContainedButton>
          <InfoIcon
            style={{ cursor: "pointer", color: "#a8a1a1", fontSize: "16px" }}
            onClick={() => setShowMarginInfo(true)}
          />
          <ContainedButton
            style={{ width: "55px" }}
            onClick={() => setShowRange(true)}
          >
            {finalbaseLeverage}X
          </ContainedButton>
          <InfoIcon
            style={{ cursor: "pointer", color: "#a8a1a1", fontSize: "16px" }}
            onClick={() => setShowRangeInfo(true)}
          />
        </div>
      </div>
      <div className="p-3">

      {activeTab === "MARKET" && (
        <FutureBuyAndSellMarket
          currencycode={currencycode}
          basecurrency={basecurrency}
          selectedBuyingAssetBalance={selectedBuyingAssetBalance}
          selectedSellingAssetBalance={selectedSellingAssetBalance}
          percentageValue={percentageValue}
          getUserTransaction={getUserTransaction}
          assetpair={assetpair}
          selelectedMarginWalletBalance={selelectedMarginWalletBalance}
          selectedLeverageMarginType={selectedLeverageMarginType}
          selectedContractBalance={selectedContractBalance}
          finalbaseLeverage={finalbaseLeverage}
          renderAvailableBalance={renderAvailableBalance}
        />
      )}
      {activeTab === "LIMIT" && (
        <FutureBuyAndSellLimit
          currencycode={currencycode}
          basecurrency={basecurrency}
          selectedBuyingAssetBalance={selectedBuyingAssetBalance}
          selectedSellingAssetBalance={selectedSellingAssetBalance}
          percentageValue={percentageValue}
          getUserTransaction={getUserTransaction}
          assetpair={assetpair}
          selelectedMarginWalletBalance={selelectedMarginWalletBalance}
          selectedLeverageMarginType={selectedLeverageMarginType}
          selectedContractBalance={selectedContractBalance}
          finalbaseLeverage={finalbaseLeverage}
          renderAvailableBalance={renderAvailableBalance}
          selectedOrderType={selectedOrderType}
        />
      )}
      {activeTab === "STOP-LIMIT" && (
        <FutureBuyAndSellStopLimit
          currencycode={currencycode}
          basecurrency={basecurrency}
          selectedBuyingAssetBalance={selectedBuyingAssetBalance}
          selectedSellingAssetBalance={selectedSellingAssetBalance}
          percentageValue={percentageValue}
          getUserTransaction={getUserTransaction}
          assetpair={assetpair}
          selelectedMarginWalletBalance={selelectedMarginWalletBalance}
          selectedLeverageMarginType={selectedLeverageMarginType}
          selectedContractBalance={selectedContractBalance}
          finalbaseLeverage={finalbaseLeverage}
          renderAvailableBalance={renderAvailableBalance}
          selectedOrderType={selectedOrderType}
          ltp={ltp}
          derivativeAssets={derivativeAssets}
        />
      )}
      </div>

      {selectedModal && (
        <InfoPopUp
          open={true}
          onClose={handleClose}
          title={selectedModal?.title}
          description={selectedModal?.description}
        />
      )}

      <ModalContent
        open={showMargin}
        onClose={handleCloseMargin}
        title={`${assetPairName} Margin Mode`}
      >
        <div className="text-center">
          <div className="d-flex justify-content-center gap-3">
            <ContainedButton onClick={() => handleSelectLeverageMarginType(2)}>
              {selectedLeverageMarginType === 2 && <FaCheckCircle />} Cross
            </ContainedButton>
            <ContainedButton onClick={() => handleSelectLeverageMarginType(1)}>
              {selectedLeverageMarginType === 1 && <FaCheckCircle />} Isolated
            </ContainedButton>
          </div>
          <p
            style={{
              marginTop: "15px",
              fontSize: "14px",
              color: "var(--text-color)",
            }}
          >
            Switching the margin mode only applies to the selected contract.
          </p>
        </div>

        <div className="text-center mt-3">
          <ContainedButton onClick={handleCloseMargin}>Confirm</ContainedButton>
        </div>

        <div className="mt-3">
          <p
            className={theme === "dark" ? "white-texts" : "text-black"}
            style={{ fontSize: "18px" }}
          >
            What are Cross and Isolated modes?
          </p>
          <br></br>
          <p className={theme === "dark" ? "grey-texts" : "text-black"}>
            <span
              className={theme === "dark" ? "white-texts" : "text-black"}
              style={{ fontSize: "18px" }}
            >
              Cross Margin Mode:
            </span>{" "}
            All cross positions under the same margin asset share the same asset
            cross margin balance. In the event of liquidation, your asset’s full
            margin balance along with any remaining open positions under the
            asset may be forfeited.
          </p>
          <br></br>
          <p className={theme === "dark" ? "grey-texts" : "text-black"}>
            <span
              className={theme === "dark" ? "white-texts" : "text-black"}
              style={{ fontSize: "18px" }}
            >
              Isolated Margin Mode:
            </span>{" "}
            Manage your risk on individual positions by restricting the amount
            of margin allocated to each. If the margin ratio of a position
            reaches 100%, the position will be liquidated. Margin can be added
            or removed to positions using this mode.
          </p>
        </div>
      </ModalContent>

      <InfoPopUp
        open={showMarginInfo}
        onClose={handleCloseMarginInfo}
        title={"CROSS"}
        description={` Click on this button to change the Margin Mode (CROSS to ISOLATED
              or vice versa).`}
      />

      <InfoPopUp
        open={showRangeInfo}
        onClose={handleCloseRangeInfo}
        title={"LEVERAGE"}
        description={` Click on the leverage button (2X) to adjust the leverage for your
              trade. You can increase leverage to 125 times your actual balance.`}
      />

      <ModalContent
        open={showRange}
        onClose={handleCloseRange}
        title={`Adjust Leverage`}
      >
        <Form>
          <InputGroup style={{ fontSize: "25px", marginBottom: "45px" }}>
            <Button
              style={{ backgroundColor: btncolor, border: "none" }}
              variant="dark"
              onClick={() => toggleCrossRange(-1)}
            >
              <FaMinus />
            </Button>
            <div
              style={{
                textAlign: "center",

                background: "#717782",
                border: "#717782",
                width: "78%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p style={{ fontSize: "20px" }}>{baseLeverage}X</p>
            </div>

            <Button
              style={{ backgroundColor: btncolor, border: "none" }}
              variant="dark"
              onClick={() => toggleCrossRange(1)}
            >
              <FaPlus />
            </Button>
          </InputGroup>

          <div className="d-flex align-items-center">
            <span style={{ color: "#fff", fontSize: "larger" }}>
              {crossRange[0]}
            </span>
            <Form.Control
              type="range"
              min="1"
              max="125"
              value={baseRangeLeverage}
              onChange={(e) => handleRangeSliderValue(e.target.value)}
              className={theme === "dark" ? "" : "form-range-light"}
              style={{
                margin: "0 10px",
                background: "#717782",
                border: "#717782",
                borderRadius: "999px",
                height: "10px",
                paddingRight: "0px",
              }}
            />
            <span style={{ color: "#fff", fontSize: "larger" }}>
              {crossRange[1]}
            </span>
          </div>

          <div className="d-flex justify-content-center mt-3">
            <Form.Control
              type="number"
              min="1"
              max="125"
              value={baseInputLeverage}
              onChange={handleRangeSliderByInput}
              style={{
                textAlign: "center",
                fontSize: "21px",
                borderRadius: "5px",
                background: "#717782",
                border: "#717782",
                outline: "none",
                width: "75px",
                color: "white",
              }}
            />

            <span style={{ margin: "4px", fontSize: "21px" }}>X</span>
          </div>
        </Form>
        <Box className="d-flex justify-content-center mt-3">
          <ContainedButton
            sx={{ width: "150px" }}
            onClick={() => {
              handleConfirmBtn();
              handleCloseRange();
            }}
          >
            Confirm
          </ContainedButton>
        </Box>
      </ModalContent>
    </div>
  );
};

export default FutureBuyAndSell;
